export { default as MultiSelect, type MultiSelectProps } from './multi-select';
